import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { GoBack } from '@/_shared/components/GoBack';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { EditEmployees } from '../components/EditEmployees';

export const PeopleReviewScreen = () => {
  const t = useTranslations('people.reviewAndFixEmployees');
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'people' });
  }, [setLayout, t]);

  return (
    <>
      <GoBack />
      <EditEmployees />
    </>
  );
};
